import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { GA_ID, CONSENT_KEY, loadGA } from "./Analytics";

export const OPEN_COOKIE_SETTINGS_EVENT = "cc-open-cookie-settings";

// Toont de banner alleen als er een GA4-ID is ingesteld en nog geen keuze is gemaakt.
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (GA_ID && !localStorage.getItem(CONSENT_KEY)) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, open);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, open);
  }, []);

  const choose = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
    if (value === "granted") loadGA();
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookievoorkeuren"
      data-testid="cookie-banner"
      className="fixed z-[60] left-4 right-4 bottom-[84px] md:bottom-6 md:left-auto md:right-6 md:max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 p-5"
    >
      <div className="flex gap-3">
        <div className="w-10 h-10 rounded-xl bg-sky-100 flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5 text-sky-600" />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-slate-800 mb-1">Mogen wij meten hoe u onze site gebruikt?</p>
          <p className="text-sm text-slate-600">
            Wij gebruiken Google Analytics (geanonimiseerd) om de website te verbeteren. Functionele cookies zijn altijd actief.{" "}
            <Link to="/cookieverklaring" className="text-sky-600 underline underline-offset-2" data-testid="cookie-banner-more-link">
              Meer informatie
            </Link>
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-4">
        <button
          onClick={() => choose("denied")}
          data-testid="cookie-decline-btn"
          className="h-11 rounded-xl border border-slate-200 text-slate-700 font-semibold hover:bg-slate-50 transition-colors"
        >
          Weigeren
        </button>
        <button
          onClick={() => choose("granted")}
          data-testid="cookie-accept-btn"
          className="h-11 rounded-xl bg-gradient-to-r from-sky-500 to-teal-500 text-white font-semibold hover:from-sky-600 hover:to-teal-600 transition-all"
        >
          Accepteren
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
